module.exports = __webpack_public_path__ + "static/media/snow_austria.194bfd40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/snow_austria.jpg
// module id = 429
// module chunks = 0